export const environment = {
    production: true,
    msw: true,
    baseApiUrl: 'https://identity.fusionsuite.net/', //V2 Production URL for Authentication
    CCM_REDIRECT_URL: 'https://demo.fusionsuite.io/',
    CCM_API_URL:
        'https://identity.fusionsuite.net/customer-complain-managment-service/',
    workspaceApiUrl: 'https://fappservices.fusionsuite.net/', //V2 Production URL for Workspace
    notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    stripePublishKey:
        'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    webSiteURL: 'https://app.fusionsuite.net/',
    downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',

    //  ,
    // baseApiUrl:
    //     'https://cloudstaging-apis-identity.sign-secure.link/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://cloudstaging-ccmapp.sign-secure.link/',
    // workspaceApiUrl:
    //     'https://cloudstaging-fappservices.sign-secure.link/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://funky-toad-evolved.ngrok-free.app/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://cloudstaging-puchcenter.sign-secure.link/',
    // CCM_REDIRECT_URL: "https://ccm.fusionsuite.localdevspace.link/",
    // stripePublishKey:
    //     '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',

    firebase: {
        apiKey: "AIzaSyDFWnPAm9Q_XwtgnMLESWURrv3epHc9NXA",
        authDomain: "testproject-c52e0.firebaseapp.com",
        projectId: "testproject-c52e0",
        storageBucket: "testproject-c52e0.firebasestorage.app",
        messagingSenderId: "204884343975",
        appId: "1:204884343975:web:b1957703cba42f370cef82",
        measurementId: "G-STVE7QR2WD"
    },

    vapidKey: "BEJLJJRzK9DjQ6CztW0HGZUC4Aj_0gvFJNGfaeUGR0AxXyCK2zY_sl5I7ckR0JH4gWkTuqclNB-gVJDwTEFkInE"

    // Stagging Urlsmnn
    // baseApiUrl: 'https://identity.cloudstaging.fu8e.space/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://app.cloudstaging.fu8e.space/customer-complain-managment-service/',
    // workspaceApiUrl: 'https://fappservices.cloudstaging.fu8e.space/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://staging.fu8e.space',
    // CCM_REDIRECT_URL: "https://ccm.fusionsuite.localdevspace.link/",

    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',



    // 2FA Dev Envirnoment
    // baseApiUrl:
    //     'https://sign-secure.link/local-gateway/app-identity/', //V2 Dev URL for Authentication
    // CCM_API_URL:
    //     'https://sign-secure.link/local-gateway/customer-complain-managment-service/',
    // workspaceApiUrl:
    //     'https://sign-secure.link/local-gateway/app-services/', //V2 Dev URL for Workspace
    // webSiteURL: 'https://sign-secure.link/',
    // downloadImageApiUrl: 'https://outbound-io.fusioninspect.com/v2/bug/file/',
    // notificationAPiUrl: 'https://pushcenter.fusionsuite.net/',
    // stripePublishKey:
    //     'pk_live_51Mo4nSAmzvicoAcQU1fyBc64OTK4QGRB7LMhrKSZQnGywpKVpI8D3jNXmy5HhVaGxC6YjgHvnL6PH9NEMuylND2d00eW5aBZQE',
    //   stripePublishKey:
    //     'pk_test_51Mo4nSAmzvicoAcQr7cNb21GKFUZghB0RJLKWdLBOZnAO6Hh2lkgdwJ7MfFZR9ldBv4RlFo4pOOapiYnvoVgtQ9R001aXsaPul',
};
